// extracted by mini-css-extract-plugin
module.exports = {"bgImg":"ZGGO5OF0U7ZSQZfwFqd0S","container":"_1tMC_4oo3KL-PPBIu6aAa5","content":"_150qtFTPTed8ODahX9gO_f","colone":"_1qWaeLvqSKyyAGscRwIFJb"};